import { useLocation, useNavigate } from 'react-router-dom';
import { processAuthentication } from 'app/services/auth';
import PATHS from 'utils/paths';

const Authenticated = (): null => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const authorizationCode = params.get('code');

    if (authorizationCode) {
      processAuthentication(authorizationCode)
        .then(() => navigate(PATHS.HOME))
        .catch(() => navigate(PATHS.SIGNIN));
    } else {
      navigate(PATHS.HOME);
    }
  }, [location.search, navigate]);

  return null;
};

export default Authenticated;
